<script setup lang="ts">
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
import { Toaster } from 'vue-sonner'

import 'vue-sonner/style.css'
</script>

<template>
    <router-view />
    <VueQueryDevtools />
    <Toaster position="top-right" />
</template>

<style scoped></style>
